import { useContext } from "react";

import { SnackbarContext } from "@/context/SnackbarProvider";

export const useSnackbar = () => {
  const { openSnackbar } = useContext(SnackbarContext);

  const showSnackbar = (message: any, variant: any, duration?: number) => {
    openSnackbar(message, variant, duration);
  };

  return { showSnackbar };
};
